import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { atualizarLogomarcaEvento } from '../../util/util';
import { getText, getParticipantLanguage } from '../../util/translations';
import api from '../../services/api';
import logo from '../../images/logoaccess.png';
import '../Login/styles.css';
import { toast } from 'react-toastify';
import Processando from '../../components/Processando';

export default function LoginConfirmarDados({ match }) {
  const id = match.params.id;
  const [data, setData] = useState(null);
  const [linkDesativado, setLinkDesativado] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const params = new URLSearchParams(window.location.search);
  const contrato = params.get('contrato');

  const buscar = () => {
    setIsLoading(true);
    setIsError(false);
    atualizarLogomarcaEvento();
    api({
      method: "get",
      action: '/dadosParticipante/' + id,
    }).then(response => {
      var dadosRecebidos = response.data.data;
      atualizarLogomarcaEvento(dadosRecebidos.evento);

      if (dadosRecebidos.evento.rsvp !== "sim") {
        setLinkDesativado(true);
        toast.warning(getText('linkDisabled', getParticipantLanguage(dadosRecebidos)));
        setIsLoading(false);
        return;
      }

      //se estiver em alguma situação do grupo "confirmado" ou "declinaram", mostrar concluído
      var gruposSituacao = dadosRecebidos.situacaoevento?.grupo ?? [];
      if (gruposSituacao.includes("confirmados") || gruposSituacao.includes("declinaram")) {
        history.push({
          pathname: "/cadastroEventoParticipanteConviteConcluido/" + dadosRecebidos.evento.id,
          state: { idioma: dadosRecebidos.idioma }
        });
      } else {
        setData(dadosRecebidos);
        setIsLoading(false);
      }
    }).catch(err => {
      setIsLoading(false);
      setIsError(true);
      const message = data ?
        `${getText('error', getParticipantLanguage(data))} ${getText('errorRefreshPage', getParticipantLanguage(data))}`
        : <>{getText('error', "portugues")} {getText('errorRefreshPage', "portugues")}<br />({getText('error', "ingles")} {getText('errorRefreshPage', "ingles")})</>;

      toast.error(message);
    });
  };//buscar

  async function salvar(e) {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await api({
        method: 'post',
        action: '/loginRapido/' + id,
      });
      var dadosRecebidos = response.data;

      localStorage.setItem('perfil', "cliente");
      localStorage.setItem('idUsuario', dadosRecebidos.id);
      localStorage.setItem('nomeUsuario', dadosRecebidos.nome);
      localStorage.setItem('token', dadosRecebidos.api_token);

      if ((data?.datacartainformativa ?? "") !== "") { //ainda não foi enviada carta informativa
        history.push("/cadastroEventoParticipanteCartaInformativa/" + id, { idioma: data?.idioma });
      } else { //já foi enviada carta informativa
        //se tiver modelo de carta convite, redirecionar para aceitar convite, senão para cadastro de dados
        if ((data?.evento?.modelocartaconvite ?? "") !== "" && data?.tipoparticipante !== "3") {
          history.push("/cadastroEventoParticipanteAceitarConvite/" + id + (contrato ? "?contrato=true" : ""), { idioma: data?.idioma });
        } else if ((data?.evento?.modelotermoaceite ?? "") !== "") { //se tiver termo de aceite
          history.push("/cadastroEventoParticipanteAceitarTermo/" + id, { idioma: data?.idioma }); //mostrar termo
        } else { //caso nao tenha termo de aceite
          history.push("/cadastroEventoParticipanteConvite/" + id, { idioma: data?.idioma }); //vai direto para cadastro de dados
        }
      }
    } catch (error) {
      toast.error(getText('error', getParticipantLanguage(data)) + getText('errorDefault', getParticipantLanguage(data)));
    } finally {
      setIsSubmitting(false);
    }
  } //salvar

  useEffect(() => { //onload
    buscar();
  },
    // eslint-disable-next-line
    []);

  return (
    <div id="auth" style={
      (data?.evento?.cor !== undefined) ? {
        backgroundImage: "none",
        backgroundColor: data?.evento?.cor,
      } : {
        backgroundImage: "none",
        backgroundColor: "#AAAAAA",
      }
    }>
      {isLoading && <Processando idioma={data?.idioma ?? "both"} />}
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-12 mx-auto">
            <div className="card pt-4">
              <div className="card-body">
                <div className="text-center mb-5">
                  {localStorage.getItem('logomarcaEvento') && (!isLoading && !isError && data?.evento) ?
                    <img alt="" src={localStorage.getItem('logomarcaEvento')} height="48" className='mb-4' /> :
                    <img alt="" src={logo} height="48" className='mb-4' />
                  }
                  {linkDesativado ? (
                    <p>{getText('deadlineExpired', getParticipantLanguage(data))}</p>
                  ) : (
                    data ?
                      <p>{getText('welcomeMessage', getParticipantLanguage(data))} <strong>{(data?.evento?.nomersvp ?? data?.evento?.nome ?? "")}</strong>!</p>
                      :
                      <p>
                        {getText('welcomeMessage', "portugues")}!
                        <br />
                        ({getText('welcomeMessage', "ingles")}!)
                      </p>
                  )}
                </div>
                {!linkDesativado && !isLoading && !isError && data?.evento && (
                  <form onSubmit={salvar}>
                    <div className="clearfix">
                      <center>
                        <button disabled={isSubmitting} className="btn btn-primary" type="submit">{getText('startRegistration', getParticipantLanguage(data))}</button>
                      </center>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
